import React from 'react';
import FormModal from '../../shared/components/custom/FormModal';
import WebsiteComponentForm from './WebsiteComponentForm';
import t, { partial } from '../../util/translation/translation';

const CustomWebsiteComponent = ({
  showModal,
  onClose,
  selectedComponent,
  onSave,
  availableEntities,
  renderDetails,
}) => {
  const compName = selectedComponent?.id?.split('specific-')[1];
  // External links have their own modal (ExternalLinkWebsiteComponent)
  if (!compName || compName === 'external-link') {
    return null;
  }
  const s = partial('shared');

  const promptTitle = `${selectedComponent?.value ? s('edit') : s('create')} ${t(`appLayout.${compName}`)}`;
  const handleSubmit = (values) => {
    const payload = {
      ...selectedComponent,
      value: values.selectedEntity.value,
      label: values.label,
    };
    onSave(payload);
  };
  return (
    <FormModal
      isOpen={!!showModal}
      onClose={onClose}
      title={promptTitle}
      subtitle={t(`appLayout.modalHint-${compName}`)}
    >
      <WebsiteComponentForm
        availableEntities={availableEntities}
        renderDetails={renderDetails?.[compName]}
        itemName={t(`appLayout.${compName}`)}
        type={selectedComponent?.value ? 'edit' : 'create'}
        component={selectedComponent}
        onSubmit={handleSubmit}
        onClose={onClose}
      />
    </FormModal>
  );
};
export default CustomWebsiteComponent;
